<template>
    <v-footer id="Footer" class="codettes-footer grey darken-3 white--text" padless>
        <v-row class="footer-main grey darken-3 white--text">
            <v-col cols="12" md="4">
                <v-card flat class="grey darken-3 white--text">
                    <v-img alt="Codettes" src='@/assets/img/logo/logo_full.svg' max-width='150px'></v-img>
                    <br/>
                    <p>Organization who's aim is to bring awareness, to educate, and train girls and young women in
                        ICT and innovation.
                    </p>
<!--                    <buy-me-a-coffee url='codettes' text='Buy us pizza' icon='fas fa-pizza-slice' color='primary' />-->
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
            </v-col>
            <v-col cols="12" md="4">
                <v-card flat class="grey darken-3 white--text">
                    <h4>Stay connected</h4>
                    <ul>
                        <li>
                            <v-icon small color="white">fas fa-map-marker-alt</v-icon>
                            Paramaribo Suriname
                        </li>
                        <li>
                            <v-icon small color="white">fas fa-phone-alt</v-icon>
                            <a href="tel://597-8822698">
                                +597-8822698
                            </a></li>
                        <li>
                            <v-icon small color="white">fab fa-whatsapp</v-icon>
                            <a href="https://wa.me/5978822698">+597-8822698</a></li>
                        <li>
                            <v-icon small color="white">fas fa-envelope</v-icon>
                            <a href="mailto:info@codettes.org">info@codettes.org</a>
                        </li>
                        <li>
                            <v-icon small color="white">fas fa-globe</v-icon>
                            <a href="https://www.codettes.org">https://www.codettes.org</a>
                        </li>
                        <li>
                            <v-icon small color="white">fab fa-facebook</v-icon>
                            <a href="https://www.facebook.com/codettesorg/" target="_blank">codettes</a>
                        </li>
                    </ul>
                </v-card>
            </v-col>
<!--            <v-col cols="12" md="4">-->
<!--                <v-card flat class="grey darken-3 white&#45;&#45;text">-->
<!--                    <h4>Sponsors</h4>-->
<!--                    <ul class="sponsors">-->
<!--                        <li>-->
<!--                            <v-img alt="U.S. Embassy" src='/usembassy.svg' min-width="50" max-width="200"/>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <v-img alt="Kosmos" src='/kosmosenergy.svg' min-width="50" max-width="200" />-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </v-card>-->
<!--            </v-col>-->
        </v-row>
        <v-row class="footer-cta grey darken-3 white--text">
            <v-col cols="12" class="text-center py-2">
                <v-btn outlined color="white" rounded class="mr-2" @click="donationDialog = true">Support Codettes</v-btn>
                <v-btn color="primary" rounded depressed href="mailto:info@codettes.org?subject=Join Codettes">Join the Codettes community</v-btn>
            </v-col>
        </v-row>
        <v-row class="bottom black">
            <v-col cols="12" sm="6">
                    Copyright &copy; {{ new Date().getFullYear() }} Codettes. All rights reserved. Design by Codettes.
            </v-col>
            <v-col cols="12" sm="6" class="footer-social-col">
                <v-spacer/>
                <ul>
                    <li><a href="https://www.instagram.com/codettesorg/" target="_blank">
                        <v-icon large color="white">fab fa-instagram</v-icon>
                    </a>
                    </li>
                    <li><a href="https://www.facebook.com/codettesorg" target="_blank">
                        <v-icon large color="white">fab fa-facebook</v-icon>
                    </a>
                    </li>
                </ul>
            </v-col>
        </v-row>
        <v-dialog v-model="donationDialog" max-width="620">
            <v-card class="donation-card">
                <v-card-title class="donation-title">Support Codettes</v-card-title>
                <v-card-text>
                    <p>Support Codettes through a bank transfer. Please use <strong>Stichting Codettes</strong> as the account name.</p>
                    <div class="account-row"><span>Bank</span><strong>Hakrinbank N.V.</strong></div>
                    <div class="account-row"><span>USD account</span><strong>20.855.70.63</strong></div>
                    <div class="account-row"><span>SRD account</span><strong>209683968</strong></div>
                    <div class="account-row"><span>Bank address</span><strong>Etnalaan 29</strong></div>
                    <div class="account-row"><span>Contact</span><strong>+597 8822698</strong></div>
                    <div class="international-note"><strong>International transfers</strong><br/>Hakrinbank SWIFT/BIC: <strong>HAKRSRPA</strong><br/>For USD transfers, your bank may also request the correspondent bank: Crown Agents Bank, SWIFT <strong>CRASGB2L</strong>.</div>
                    <p class="donation-footnote">Confirm the current routing instructions with your bank or Hakrinbank before sending an international transfer.</p>
                </v-card-text>
                <v-card-actions><v-spacer/><v-btn text color="primary" @click="donationDialog = false">Close</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
    </v-footer>
</template>

<script>
    // import BuyMeACoffee from "../components/BuyMeACoffee";
    export default {
        name: "CodettesFooter",
        data: () => ({ donationDialog: false })
        // ,
        // components: {BuyMeACoffee}
    }
</script>

<style scoped>
.codettes-footer {
    background: #24123f !important;
    border-top: 4px solid #ce128a;
    position: relative;
    z-index: 1;
}
.footer-main { padding: 46px 7% 30px; }
.footer-main .v-card { background: transparent !important; }
.footer-main p { color: #d9cfe4; line-height: 1.65; max-width: 420px; }
.footer-main h4 { color: #fff; font-size: 1.1rem; letter-spacing: .02em; margin: 0 0 16px; }
.footer-main ul { margin: 0; padding: 0; }
.footer-main li { align-items: center; display: flex; gap: 10px; margin: 11px 0; }
.codettes-footer a { color: #f1a9db; }
.footer-cta { border-top: 1px solid rgba(255,255,255,.14); padding: 22px 7%; }
.footer-cta .v-btn { box-shadow: 0 8px 22px rgba(206,18,138,.25); }
.bottom { align-items: center; padding: 14px 7%; }
.bottom .footer-social-col { text-align: right; }
    .sponsors li {
        display: inline-block;
    }

    .sponsors li .v-image {
        background: #ff00;
        border: 0;
    }

    ul {
        list-style: none;
    }

.bottom li {
        display: inline-block;
        margin-left: 14px;
    }
.donation-title { background: #24123f; color: #fff; font-size: 1.45rem; }
.donation-card p { color: #5d5368; line-height: 1.6; }
.account-row { align-items: center; border-bottom: 1px solid #eee5f3; display: flex; justify-content: space-between; gap: 16px; padding: 10px 0; }
.account-row span { color: #746b7d; font-size: .88rem; }
.account-row strong { color: #24123f; text-align: right; }
.international-note { background: #f6f1fa; border-left: 3px solid #ce128a; color: #5d5368; line-height: 1.6; margin-top: 18px; padding: 14px; }
.donation-footnote { font-size: .8rem; margin: 18px 0 0; }

    @media (max-width: 600px) {
        .footer-main { padding: 34px 20px 18px; }
        .footer-cta { padding: 20px; }
        .footer-cta .v-btn { margin-top: 12px; }
        .bottom { padding: 14px 20px; }
        .bottom .footer-social-col { text-align: left; }
        .bottom li { margin-left: 0; margin-right: 14px; }
    }

</style>
